import React, {useState, useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';

import {
  getPhoneNumber,
  getStoreCode,
  getStoreInformation,
  setLandedFirstTimeCount,
  setLmrFirstStatus,
  setMetadata,
  setSearchUser,
  setSignUp,
  setStoreInformation,
} from '../../core/localstorage-data';
import cogoToast from 'cogo-toast';
import {
  getAccessToken,
  setAccessToken,
  setPhoneNumber,
} from '../../core/localstorage-data';
import {
  otpAccessToken,
  errorInOtpVerification,
  otpVerificationIsloading,
  checkOtp,
  resetState,
} from '../../redux/otpVerifySlice';
import {
  error,
  loading,
  customerProfile,
  fetchCustomerProfile,
} from '../../redux/customerSearchSlice';
import {HOME_ROUTE_PATH} from '../../routes/route-constants';
import {setUserLoggedIn} from '../../redux/globalSlice';
import OtpTnC from './Otptnc';
import {
  fetchStoreInformation,
  storeInformation,
} from '../../redux/storeInformationSlice';
import {getWithExpiry, setWithExpiry} from '../../core/localstorage-utils';
import ErrorToast from '../../components/notifications/ErrorToast';
import {fetchCouponPoints, fetchOffers} from '../../redux/offerSlice';
import {fetchMetadata, metadata} from '../../redux/metadataSlice';
import {fetchOrder} from '../../redux/orderSlice';
import {setTourGuide} from '../../redux/tourGuideSlice';
import {
  couponPoints,
  errorInCouponApi,
  couponIsLoading,
} from '../../redux/offerSlice';
import {sessionTimeHandler} from '../../lib/sessionTimeHandler';

import {
  getAllCustomerCoupon,
  CouponResp,
  errorCouponData,
  loadingcouponData,
  couponData,
} from '../../redux/getCouponSlice';
import {loginEventGA} from '../../lib/tagmanager';

//import { sessionTimeHandler } from '../../lib/sessionTimeout';

let finalOtpJointData = '';
let count = 12;
const counterTwo = 0;
export const Otpinput = ({
  tokenData,
  phoneNumber,
  onResend,
  onOpenTnCModel,
  sendOTPButton,
}: any) => {
  const otpvarifyHasErrorMessage = useAppSelector(errorInOtpVerification);
  const otpVerifyHasLoaded = useAppSelector(otpVerificationIsloading);
  const couponApiHasError = useAppSelector(errorInCouponApi);
  const coupanApiHasLoaded = useAppSelector(couponIsLoading);
  const couponPointsDataFromAPI = useAppSelector(couponPoints);

  const couponResponse = useAppSelector(CouponResp);
  const errorInCOuponData = useAppSelector(errorCouponData);
  const loadingCouponData = useAppSelector(loadingcouponData);
  const couponApiComplete = useAppSelector(couponData);
  const otpVerification = useAppSelector(otpAccessToken);
  const customerSearchHasErrorMessage = useAppSelector(error);
  const customerSeachHasLoaded = useAppSelector(loading);
  const customerProfileData = useAppSelector(customerProfile);
  const storeInformationData = useAppSelector(storeInformation);
  const metdataData = useAppSelector(metadata);
  const [showResendButton, setShowResendButton] = useState(false);
  const [timer, setShowTimer] = useState(32);
  const [resentButtonClicked, setResetButtonClicked] = useState(false);
  const [displayTimer, setDisplayTimer] = useState(false);
  let timeInterval = 0;
  const dispatch = useAppDispatch();
  const navigate = useHistory();
  const [otp, setOtp] = useState(new Array(4).fill(''));
  const storeCode = getStoreInformation().store_code;
  const storeName = getStoreInformation().store_name;
  useEffect(() => {
    if (sendOTPButton === true) {
      setShowTimer(32);
      setDisplayTimer(false);
      setShowResendButton(false);
      showTimer(32);
    }
  }, [sendOTPButton]);
  useEffect(() => {
    if (couponApiHasError != '') {
      const sampleToken = getAccessToken();

      if (sampleToken) {
        const data = {
          accessToken: sampleToken,
        };
        dispatch(getAllCustomerCoupon(data));
      }
    }
    if (
      couponPointsDataFromAPI !== null &&
      couponPointsDataFromAPI.message != ''
    ) {
      if (couponPointsDataFromAPI.firstLogin === 'True') {
        setLmrFirstStatus('true');
        dispatch(setTourGuide(true));
      }
      const sampleToken = getAccessToken();

      if (sampleToken) {
        const data = {
          accessToken: sampleToken,
        };
        dispatch(getAllCustomerCoupon(data));
      }
    }
  }, [couponPointsDataFromAPI, couponApiHasError, coupanApiHasLoaded]);

  useEffect(() => {
    if (couponApiComplete === true) {
      if (couponResponse && couponResponse.coupons) {
        setWithExpiry('coupon_point_details', couponResponse.coupons);
      } else {
        //
      }
      const sampleToken = getAccessToken();
      if (sampleToken) {
        const parameters = {
          payload: {
            source: 'Saturam',
            locationCode: 'BNG',
            mobileNumber: phoneNumber,
          },
          accessToken: sampleToken,
        };
        // const payload = {
        //   mobile_number: phoneNumber,
        //   store_input_code: getStoreCode(),
        // };
        // dispatch(fetchStoreInformation(payload));
        dispatch(fetchCustomerProfile(parameters));
        dispatch(resetState());
      }
    }
    if (
      (errorInCOuponData === 'null' || errorInCOuponData != '') &&
      loadingCouponData === false
    ) {
      const sampleToken = getAccessToken();
      if (sampleToken) {
        const parameters = {
          payload: {
            source: 'Saturam',
            locationCode: 'BNG',
            mobileNumber: phoneNumber,
          },
          accessToken: sampleToken,
        };
        // const payload = {
        //   mobile_number: phoneNumber,
        //   store_input_code: getStoreCode(),
        // };
        // dispatch(fetchStoreInformation(payload));
        dispatch(fetchCustomerProfile(parameters));
        dispatch(resetState());
      }
    }
  }, [couponResponse, errorInCOuponData, loadingCouponData, couponApiComplete]);
  function showTimer(num?: number) {
    setTimeout(() => {
      setDisplayTimer(true);
    }, 2000);
    if (timer === 0) {
      setShowTimer(32);
      setTimeout(() => {
        setDisplayTimer(true);
      }, 2000);
    }
    // if (timer > 0) {
    //   setTimeout(() => setShowTimer(timer - 1), 1000);
    // }

    // setTimeout(() => {
    //   setShowResendButton(true);
    // }, 33000);
    timeInterval = window.setInterval(() => {
      if (!num && timer === 0) {
        return;
      }
      count--;
      //console.log(timer);
      setShowTimer(prevTime => {
        // console.log(prevTime);
        if (prevTime === 0) {
          console.log(prevTime);
          clearInterval(timeInterval);
          setShowResendButton(true);
          return prevTime;
        }
        return prevTime - 1;
      });
    }, 1000);
  }
  useEffect(() => {
    if (resentButtonClicked === true) {
      //console.log('call');
      showTimer();
      setResetButtonClicked(false);
    }
  }, [resentButtonClicked]);
  const handleOnResend = () => {
    setResetButtonClicked(true);
    setShowResendButton(false);
    setShowTimer(32);
    setDisplayTimer(false);
    showTimer();
    //console.log("commented")
    setOtp(new Array(4).fill(''));
    onResend();
  };

  useEffect(() => {
    if (otpVerification != '' && otpVerifyHasLoaded == false) {
      setAccessToken(otpVerification);
      setPhoneNumber(phoneNumber);
      setLandedFirstTimeCount(0);
      sessionTimeHandler('');
    }
    if (otpvarifyHasErrorMessage != '' && otpVerifyHasLoaded == false) {
      cogoToast.error(
        <ErrorToast title="Error" description="Incorrect OTP" />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  }, [otpvarifyHasErrorMessage, otpVerifyHasLoaded, otpVerification]);

  useEffect(() => {
    if (otpVerification != '') {
      const sampleToken = getAccessToken();

      if (sampleToken) {
        console.log(sampleToken);
        const parameters = {
          accessToken: sampleToken,
          payload: {
            keyId: getStoreCode(),
            storecode: storeCode,
          },
        };
        dispatch(fetchCouponPoints(parameters));

        //        dispatch(resetState());
      }
    }
  }, [otpVerification]);

  // function matchUserSession(customerProfileData: any) {
  //   const cardNumber = getWithExpiry('coupon_card_number');
  //   if (cardNumber !== customerProfileData.cardNumber) {
  //     localStorage.removeItem('coupon_card_number');
  //     localStorage.removeItem('coupon_point_details');
  //   }
  // }

  useEffect(() => {
    if (
      storeInformationData !== null &&
      storeInformationData.result === true &&
      customerProfileData.result == true &&
      customerSeachHasLoaded == false &&
      customerProfileData.resultCode == 'SUCCESS'
    ) {
      setStoreInformation(storeInformationData);
      dispatch(setUserLoggedIn(true));
      setSearchUser(customerProfileData);
      //GTM Event
      loginEventGA(
        getStoreCode(),
        storeCode,
        getPhoneNumber(),
        customerProfileData.cardNumber,
        customerProfileData.tier,
        storeName,
      );
      navigate.push(HOME_ROUTE_PATH);
      //window.location.href = HOME_ROUTE_PATH;
      // const cardNumber = getWithExpiry('coupon_card_number');
      // if (cardNumber !== customerProfileData.cardNumber) {
      //   localStorage.removeItem('coupon_card_number');
      //   localStorage.removeItem('coupon_point_details');
      // }
      const parameters = {
        payload: {mobileNumber: phoneNumber, ouCode: 'MAX'},
        accessToken: getAccessToken(),
      };
      dispatch(fetchOffers(parameters));
      // const params = {
      //   accessToken: getAccessToken(),
      //   payload: {
      //     storeCode: `0${storeInformationData.store_code}`,
      //     cardNumber: customerProfileData.cardNumber,
      //     storeKeyId: getStoreCode(),
      //   },
      // };
      // dispatch(fetchOrder(params));
      // const parameters = {
      //   payload: {mobileNumber: phoneNumber, ouCode: 'LS'},
      //   accessToken: getAccessToken(),
      // };
      // dispatch(fetchOffers(parameters));

      //  matchUserSession(customerProfileData);
      //console.log(otp);
    }
    if (
      customerProfileData.result == false &&
      customerSeachHasLoaded == false &&
      customerProfileData.resultCode == '5'
    ) {
      setSignUp();
      navigate.push('./signup');
    }
  }, [
    customerSearchHasErrorMessage,
    customerSeachHasLoaded,
    customerProfileData,
    storeInformationData,
  ]);

  useEffect(() => {
    if (storeInformationData && storeInformationData.store_code) {
      dispatch(fetchMetadata(storeInformationData.store_code));
    }
  }, [storeInformationData]);

  useEffect(() => {
    if (metdataData !== null) {
      setMetadata(metdataData);
    }
  }, [metdataData]);

  const handleChange = (element: any, index: any) => {
    if (isNaN(element.value)) return false;
    //console.log(element.value.length);
    if (element.value.length > 1) {
      return;
    }

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
    //console.log(otp);

    //Focus next input
    if (element.value.trim() !== '' && element.nextSibling) {
      element.nextSibling.focus();
    }
  };
  const finalOtp = otp.join('');
  if (finalOtp.length === 4) {
    //setJointOtp(finalOtp);
    finalOtpJointData = finalOtp;
  }

  // if (finalOtpJointData != '') {
  //   console.log('Its working', finalOtpJointData);
  // }
  const handleSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault();
    const payload = {
      token: tokenData,
      mobileNum: phoneNumber,
      code: finalOtpJointData,
    };
    setOtp(new Array(4).fill(''));
    dispatch(checkOtp(payload));
  };

  const isOTPNotFilled = () => {
    return otp.some(field => field.trim() === '');
  };

  return (
    <div className="">
      <div className="">
        <p className="font-roboto text-base font-medium text-center mt-5 mb-2">
          OTP Verification
        </p>
        <p className="w-full font-roboto text-xs text-black_zero text-opacity-50 mt-0.5">
          Enter the OTP you received on +91-{phoneNumber}
        </p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="flex justify-between mt-5 content-center">
          {otp.map((data, index) => {
            return (
              <input
                type="number"
                {...(index === 0 ? {autoFocus: true} : {})}
                key={index}
                value={data}
                onKeyDown={e =>
                  (e.keyCode === 69 || e.keyCode === 190 || e.key == '-') &&
                  e.preventDefault()
                }
                min="0"
                onChange={e => handleChange(e.target, index)}
                className="w-14 h-12 bg-blue_four border-light_blue border focus:outline-none focus:ring-1 focus:ring-blue_border text-center rounded-radius10"
                maxLength={1}
              />
            );
          })}
        </div>
        <div>
          {showResendButton ? (
            <div>
              <p className="h-3.5 font-sans:Roboto text-xs text-black_zero text-opacity-50 text-center  mt-3">
                Didn’t receive the OTP? &nbsp;
                <Link
                  to="#"
                  className="text-red-600 font-bold"
                  onClick={handleOnResend}>
                  Resend OTP
                </Link>
              </p>
            </div>
          ) : displayTimer ? (
            <div className="h-3.5 font-sans:Roboto ">
              <span className="text-xs font-bold"> {timer}</span>
              <span className="text-xs text-black_zero text-opacity-90 text-center  mt-3">
                &nbsp;seconds to generate the new &nbsp;
              </span>
              <span className="text-xs text-red-600 font-bold">OTP</span>
            </div>
          ) : (
            ' '
          )}
        </div>
        <div className="grid place-items-center">
          <button
            className="w-full h-14 primary pressed mt-6 text-white font-bold focus:outline-none"
            type="submit"
            disabled={isOTPNotFilled()}>
            Continue
          </button>
        </div>
        <OtpTnC
          classes="mt-6"
          openTnCModal={() => {
            onOpenTnCModel();
          }}
        />
      </form>
    </div>
  );
};
